import React from "react";
import logoImg from "../img/logo2.png";
import { ButtonBig, ButtonSmall } from "../components/Button";
import Modal from "../components/Modal";

function MainPage() {
  return (
    <>
      <div id="contents" className="visualMain">
        <p>
          나와 궁합이 잘 맞는<em>MBTI</em>를 쉽게 찾아보자 !
        </p>
        <h1>
          찰떡궁합 MBTI
          <img src={logoImg} alt="logo" />
        </h1>
        <ButtonBig dataLink="/select" title="테스트 시작하기" />
        <ButtonSmall leftTitle="공유하기" rightTitle="검사하기" />
      </div>
      <Modal infoLink="zihoyam.com/mbti-project"></Modal>
    </>
  );
}

export default MainPage;
